/* ============================================================
   Schnerds Theme — JS
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {
  initFloatAnimations();
  initScrollReveal();
  initEnhancedScrollReveal();
  initPersonalityBarAnimation();
  initCartBounce();
  initPageTransition();
  // initHeroParticles() is disabled — its container is permanently
  // `display:none !important` in CSS, so the DOM/random work it does
  // every page load was pure overhead with no visible effect.
  initScoreCounter();
  initQuiz();
  initAddToCart();
  initHeaderHeightVar();
});

/* ---- Sitewide header-height CSS var ----
   .sn-header is position:sticky at top:0 with real, variable height
   (the announcement bar can wrap to 2 lines on narrow screens, and now
   only shows on the homepage template at all). Any anchor target or
   sticky element anywhere on the site that needs to sit below the
   header — #quiz, the collection-page toolbar — reads this instead of
   guessing a fixed pixel offset that breaks whenever the header's real
   height changes. Previously only measured on /collections/all; moved
   here after a live check found #quiz itself (linked from off-page)
   landing tucked under the header with no var available to use. */
function initHeaderHeightVar() {
  var header = document.querySelector('.sn-header');
  if (!header) return;
  function update() {
    document.documentElement.style.setProperty('--sn-header-h', header.getBoundingClientRect().height + 'px');
  }
  update();
  window.addEventListener('resize', update);
}

function initFloatAnimations() {
  document.querySelectorAll('.sn-hc').forEach(el => el.classList.add('sn-float'));
}

function initScrollReveal() {
  const cards = document.querySelectorAll('.sn-char-card');
  if (!cards.length) return;
  const io = new IntersectionObserver(entries => {
    entries.forEach((e, i) => {
      if (e.isIntersecting) {
        setTimeout(() => e.target.classList.add('sn-in'), i * 80);
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.1 });
  cards.forEach(c => io.observe(c));
}

/* ---- Quiz ---- */
const QUIZ_DATA = {
  questions: [
    {
      q: "You walk into somewhere new. What do you do first?",
      opts: [
        { text: "Scope the room, figure out the vibe before joining anything", char: 'juniper',      emoji: '👀' },
        { text: "Find one real person and have a real conversation",             char: 'loveyourself', emoji: '🤝' },
        { text: "Make your own corner. You'll join when it feels right",         char: 'darlene',      emoji: '🏡' },
        { text: "Start talking. You can figure the rest out later",             char: 'jimbob',       emoji: '💬' },
        { text: "Dream about what this could eventually become",                 char: 'hobart',       emoji: '💭' }
      ]
    },
    {
      q: "Someone close to you is going through it. You...",
      opts: [
        { text: "Listen first, talk second",                                      char: 'loveyourself', emoji: '👂' },
        { text: "Share your own experience with feeling lost",                    char: 'hobart',       emoji: '🤗' },
        { text: "Give them space. Sometimes that's what's needed",               char: 'darlene',      emoji: '🕊️' },
        { text: "Tell them what you'd do. You have a lot of thoughts",           char: 'jimbob',       emoji: '💡' },
        { text: "Ask what kind of support they actually want",                    char: 'juniper',      emoji: '❓' }
      ]
    },
    {
      q: "What do people most misunderstand about you?",
      opts: [
        { text: "That being quiet means I'm not paying attention",                char: 'darlene',      emoji: '🤫' },
        { text: "That dreaming isn't the same as not trying",                     char: 'hobart',       emoji: '✨' },
        { text: "That wanting to belong isn't the same as being needy",           char: 'juniper',      emoji: '🫂' },
        { text: "That I talk a lot, but I'm actually a great listener when I try",   char: 'jimbob',       emoji: '🗣️' },
        { text: "That loving yourself isn't selfish",                             char: 'loveyourself', emoji: '💗' }
      ]
    },
    {
      q: "Which feeling do you know best?",
      opts: [
        { text: "Wanting to belong somewhere and not being sure where that is",   char: 'juniper',      emoji: '🧭' },
        { text: "Knowing you're different and still figuring out how you feel",   char: 'darlene',      emoji: '🌀' },
        { text: "Hope that something big is coming, even when things are messy",  char: 'hobart',       emoji: '🌅' },
        { text: "The itch to share what's in your head before you lose it",       char: 'jimbob',       emoji: '⚡' },
        { text: "Catching yourself being way too hard on yourself",               char: 'loveyourself', emoji: '💙' }
      ]
    },
    {
      q: "End of a hard week. You...",
      opts: [
        { text: "Need quiet and space to remember who you are",                   char: 'darlene',      emoji: '🌿' },
        { text: "Let yourself feel hopeful about next week",                      char: 'hobart',       emoji: '🌟' },
        { text: "Figure out what you actually need right now",                    char: 'juniper',      emoji: '🧭' },
        { text: "Text five people and end up in three conversations at once",     char: 'jimbob',       emoji: '📱' },
        { text: "Do something that's entirely, unapologetically for you",         char: 'loveyourself', emoji: '✨' }
      ]
    }
  ],
  results: {
    darlene:      { name: 'Darlene',                  nameImg: 'name-darlene.png',      feel: 'Neurospicy. Different by design.',    desc: 'You see the world in a way most people don\'t, and you\'re learning, slowly and imperfectly, to love yourself for it. Darlene gets it.',                                                                              img: 'schnerds-darlene.png',      color: '#4A8FD4', btnText: '#fff',    url: '/products/blue-schnerd-plush' },
    hobart:       { name: 'Hobart',                   nameImg: 'name-hobart.png',       feel: 'Trashcan dreams.',                    desc: 'You\'re in a period of transition and you have an unshakable faith that something more is on its way. Hobart has been there.',                                                                               img: 'schnerds-hobart.png',       color: '#E8920E', btnText: '#fff',    url: '/products/trash-schnerd-plush' },
    juniper:      { name: 'Juniper',                  nameImg: 'name-juniper.png',      feel: 'Driver and passenger.',               desc: 'You\'re tuned into the room, the vibe, where you fit. You\'re learning when to steer and when to go with the flow. That\'s Juniper.',                                                                    img: 'schnerds-juniper.png',      color: '#D4A017', btnText: '#1A1614', url: '/products/schnerdmarine-plush-pre-order' },
    jimbob:       { name: 'JimBob',                   nameImg: 'name-jimbob.png',       feel: 'Talking at, not to.',                 desc: 'You have a lot to say and you care a lot. You\'re working on the listening part. JimBob is right there with you.',                                                                                       img: 'schnerds-jimbob.png',       color: '#3DBB4E', btnText: '#fff',    url: '/products/schenrdfish-plush-pre-order' },
    loveyourself: { name: 'The Love Yourself Schnerd', nameImg: 'name-loveyourself.png', feel: 'The longest relationship.',           desc: 'You know the most important relationship in your life is the one with yourself. The Love Yourself Schnerd reminds you to treat that person accordingly.',                                                   img: 'schnerds-loveyourself.png', color: '#FF2E92', btnText: '#fff',    url: '#newsletter', comingSoon: true }
  }
};

function initQuiz() {
  const game        = document.getElementById('sn-qgame');
  const result      = document.getElementById('sn-qresult');
  const qEl         = document.getElementById('sn-qq');
  const optsEl      = document.getElementById('sn-qopts');
  const progBar     = document.getElementById('sn-qprogbar');
  const imgEl       = document.getElementById('sn-rimg');
  const nameImgEl   = document.getElementById('sn-rname-img');
  const feelEl      = document.getElementById('sn-rfeel');
  const descEl      = document.getElementById('sn-rdesc');
  const runnerUpEl  = document.getElementById('sn-rrunnerup');
  const adoptBtn    = document.getElementById('sn-radopt');
  const shareBtn    = document.getElementById('sn-rshare');
  const shareTxtEl  = document.getElementById('sn-rshare-text');
  const againBtn    = document.getElementById('sn-qagain');
  const quizEl      = document.querySelector('.sn-quiz');
  if (!game) return;

  let step = 0;
  const scores = { darlene: 0, hobart: 0, juniper: 0, jimbob: 0, loveyourself: 0 };
  const base = document.querySelector('[data-schnerds-asset-base]')?.dataset.schnerdsAssetBase || '';

  function resolveAsset(filename) {
    return base ? base.replace('FILENAME', filename) : filename;
  }

  function updateProgress() {
    // Dots (legacy, hidden but kept)
    document.querySelectorAll('.sn-qdot').forEach((dot, i) => {
      dot.className = 'sn-qdot';
      if (i < step)        dot.classList.add('sn-qdot-done');
      else if (i === step) dot.classList.add('sn-qdot-active');
    });
    // Progress bar fill
    if (progBar) progBar.style.width = `${(step / QUIZ_DATA.questions.length) * 100}%`;
    // ...and the same value as real progressbar semantics, not just a width.
    const progTrack = progBar?.closest('[role="progressbar"]');
    if (progTrack) {
      progTrack.setAttribute('aria-valuemax', String(QUIZ_DATA.questions.length));
      progTrack.setAttribute('aria-valuenow', String(step));
      progTrack.setAttribute('aria-valuetext', `Question ${step + 1} of ${QUIZ_DATA.questions.length}`);
    }
    // "Question X of 5" label
    const label = document.getElementById('sn-qv2-label');
    if (label) label.textContent = `Question ${step + 1} of ${QUIZ_DATA.questions.length}`;
  }

  function animateIn(el) {
    el.classList.remove('sn-q-enter');
    void el.offsetWidth;
    el.classList.add('sn-q-enter');
  }

  function renderQuestion() {
    const q = QUIZ_DATA.questions[step];

    updateProgress();
    animateIn(qEl);
    // ✦ accent marks around question (#16)
    qEl.innerHTML = `<span class="sn-q-sparkle" aria-hidden="true">✦ </span>${q.q.replace(/&/g,'&amp;').replace(/</g,'&lt;')}<span class="sn-q-sparkle" aria-hidden="true"> ✦</span>`;
    optsEl.innerHTML = '';

    const shuffled = [...q.opts].sort(() => Math.random() - 0.5);
    shuffled.forEach((opt, i) => {
      const btn = document.createElement('button');
      btn.className = 'sn-qopt sn-qopt-enter';
      btn.style.animationDelay = `${i * 60}ms`; // staggered entry — improvement #4
      btn.innerHTML = `<span class="sn-qemoji" aria-hidden="true">${opt.emoji}</span><span>${opt.text}</span>`;
      btn.addEventListener('click', () => pick(opt.char, btn));
      optsEl.appendChild(btn);
    });
  }

  function pick(char, btn) {
    document.querySelectorAll('.sn-qopt').forEach(b => { b.disabled = true; });
    btn.classList.add('sn-qopt-selected');
    quizEl?.classList.add('sn-quiz-started'); // shrink heading after first answer
    scores[char]++;

    setTimeout(() => {
      step++;
      if (progBar) progBar.style.width = `${(step / QUIZ_DATA.questions.length) * 100}%`;
      if (step < QUIZ_DATA.questions.length) {
        renderQuestion();
        // Move focus to the new question. Without this the button that had
        // focus has just been disabled and replaced, so focus falls back to
        // <body>: a keyboard user is dropped to the top of the page mid-quiz
        // and a screen-reader user is never told what the next question is.
        qEl?.focus();
      } else {
        showResult();
        // Same for the reveal -- the result is the payoff and it used to
        // appear silently, with focus still nowhere.
        result?.focus();
      }
    }, 160);
  }

  function showResult() {
    const sorted = Object.entries(scores).sort((a, b) => b[1] - a[1]);
    const winner    = sorted[0][0];
    const runnerUp  = sorted[1][0];
    const r  = QUIZ_DATA.results[winner];
    const r2 = QUIZ_DATA.results[runnerUp];

    imgEl.src = resolveAsset(r.img);
    imgEl.alt = r.name;

    // The character image reads as tappable (it's the whole point of the
    // reveal) but had nothing wired to it — on mobile that meant a tap
    // landed on nothing, which read as "it just scrolled the page."
    // Give it the same destination as the Adopt button below: the real
    // product page, or #newsletter for a not-yet-released character.
    imgEl.style.cursor = 'pointer';
    imgEl.setAttribute('role', 'link');
    imgEl.setAttribute('tabindex', '0');
    imgEl.setAttribute('aria-label', r.comingSoon ? `Notify me when ${r.name.replace('The ', '').replace(' Schnerd', '')} drops` : `View ${r.name}`);
    const goToResult = () => { window.location.href = r.url || '#shop'; };
    imgEl.onclick = goToResult;
    imgEl.onkeydown = (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); goToResult(); } };

    if (r.nameImg && nameImgEl) {
      nameImgEl.src = resolveAsset(r.nameImg);
      // Deliberately no alt: the markup marks this aria-hidden because the
      // illustration above already carries the character's name. Setting it
      // here announced the same name twice in a row.
      nameImgEl.alt = '';
      nameImgEl.style.display = 'block';
    } else if (nameImgEl) {
      nameImgEl.style.display = 'none';
    }

    feelEl.textContent = r.feel;
    descEl.textContent = r.desc;

    // Runner-up — improvement #7
    if (runnerUpEl && r2 && winner !== runnerUp) {
      runnerUpEl.textContent = `You've also got a bit of ${r2.name} in you.`;
    }

    // Character-colored adopt button — improvement #7 (result). Links to
    // that character's real product page (r.url); Love Yourself isn't a
    // real product yet, so it points at #newsletter instead (same
    // "Coming soon / Notify me" treatment as her Meet the Herd card) and
    // gets that card's own button copy instead of "Adopt".
    if (adoptBtn) {
      adoptBtn.textContent       = r.comingSoon ? `Notify me when ${r.name.replace('The ', '').replace(' Schnerd', '')} drops` : `Adopt ${r.name} →`;
      adoptBtn.href              = r.url || '#shop';
      adoptBtn.style.background  = r.color;
      adoptBtn.style.borderColor = r.color;
      adoptBtn.style.color       = r.btnText;
    }

    // Share button with character name — improvement #10
    if (shareBtn && shareTxtEl) {
      const shareText = `I got ${r.name} on the "Which Schnerd Are You?" quiz: "${r.feel}" Find yours at schnerds.com`;
      shareBtn.href = `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}`;
      shareTxtEl.textContent = `Share that you're a ${r.name}`;
    }

    // Fill progress bar to 100%
    if (progBar) progBar.style.width = '100%';

    game.style.display = 'none';
    result.classList.add('sn-show');
    // Hide "might be matched" preview when result shows (#28)
    const preview = document.getElementById('sn-qv2-preview');
    if (preview) preview.style.display = 'none';
  }

  function reset() {
    Object.keys(scores).forEach(k => scores[k] = 0);
    step = 0;
    if (progBar) progBar.style.width = '0%';
    quizEl?.classList.remove('sn-quiz-started');
    result.classList.remove('sn-show');
    game.style.display = '';
    const preview = document.getElementById('sn-qv2-preview');
    if (preview) preview.style.display = '';
    renderQuestion();
  }

  againBtn?.addEventListener('click', reset);
  renderQuestion();
}

/* ---- Add to cart (AJAX) ---- */
function initAddToCart() {
  document.querySelectorAll('[data-sn-add-to-cart]').forEach(form => {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const btn = form.querySelector('.sn-add-btn');
      const variantId = form.querySelector('[name="id"]')?.value;
      if (!variantId || !btn) return;

      const original = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding...';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: Number(variantId), quantity: 1 })
        });
        if (!res.ok) throw new Error('Cart error');

        const cartRes  = await fetch('/cart.js');
        const cartData = await cartRes.json();
        document.querySelectorAll('[data-sn-cart-count]').forEach(el => {
          el.textContent = cartData.item_count;
          el.style.display = cartData.item_count > 0 ? 'flex' : 'none';
          // Keep the cart link's accessible name in sync too — the
          // count badge itself is aria-hidden, so a screen reader
          // otherwise never learns the quantity changed at all.
          const cartLink = el.closest('.sn-cart-btn');
          if (cartLink) {
            const n = cartData.item_count;
            cartLink.setAttribute('aria-label', `Shopping Bag, ${n} item${n === 1 ? '' : 's'}`);
          }
        });

        btn.textContent = 'Added!';
        fireConfetti(btn);
        setTimeout(() => { btn.textContent = original; btn.disabled = false; }, 1800);
      } catch {
        btn.textContent = 'Try again';
        btn.disabled = false;
      }
    });
  });
}

/* ============================================================
   Interactive Design — Parallax, Scroll Animations,
   Micro-interactions, 3D Transforms, Motion Design
   ============================================================ */

/* ---- Enhanced Scroll Reveal ---- */
function initEnhancedScrollReveal() {
  // Tag elements for reveal
  var revealSelectors = [
    '.sn-char-card',
    '.sn-pdp-about > div',
    '.sn-pdp-specs-row > div',
    '.sn-pdp-reviews',
    '.sn-pdp-accessories',
    '.sn-rv-header-row',
    '.sn-ls-v4-caption',
    '.sn-pdp-creator-v2',
    '.sn-qv2-header',
    '.sn-qv2-wrap',
    '.sn-qv2-preview',
    '.sn-ls-caption',
    '.sn-pdp-bars',
    '.sn-pdp-video',
    '.sn-pdp-compare',
    '.sn-pdp-herd-card',
    '.sn-prod',
    '.sn-edu2-tool',
    '.sn-edu2-video-wrap',
    '.sn-edu2-pedagogy',
    '.sn-edu2-who-chip',
    '.sn-cs-hero',
    '.sn-cs-card',
    '.sn-pdp-book-promo',
    '.sn-ed-uc-card'
  ];

  var all = [];
  revealSelectors.forEach(function(sel) {
    document.querySelectorAll(sel).forEach(function(el, i) {
      if (!el.classList.contains('sn-will-reveal')) {
        el.classList.add('sn-will-reveal');
        el.style.transitionDelay = (i % 5) * 60 + 'ms';
        all.push(el);
      }
    });
  });

  var io = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) {
        e.target.classList.add('sn-revealed');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.08 });

  all.forEach(function(el) { io.observe(el); });
}

/* ---- 3D Card Tilt (mousemove perspective effect) ---- */
function init3DCardTilt() {
  var tiltTargets = document.querySelectorAll(
    '.sn-char-card, .sn-prod-v2, .sn-qv2-card, .sn-pdp-review-card, .sn-pdp-review-featured'
  );

  tiltTargets.forEach(function(card) {
    card.style.transition = 'transform 0.15s ease, box-shadow 0.15s ease';
    card.addEventListener('mousemove', function(e) {
      var rect = card.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width - 0.5;
      var y = (e.clientY - rect.top) / rect.height - 0.5;
      card.style.transform = 'perspective(700px) rotateX(' + (-y * 7) + 'deg) rotateY(' + (x * 7) + 'deg) translateZ(6px)';
      card.style.boxShadow = '0 ' + (8 + Math.abs(y) * 10) + 'px ' + (24 + Math.abs(x) * 20) + 'px rgba(26,22,20,0.15)';
    });
    card.addEventListener('mouseleave', function() {
      card.style.transform = '';
      card.style.boxShadow = '';
    });
  });
}

/* ---- Hero Mouse Parallax (depth on mousemove) ---- */
function initHeroMouseParallax() {
  var hero = document.querySelector('.sn-hero');
  if (!hero || window.innerWidth < 820) return;

  var leftCol  = hero.querySelector('.sn-hero-chars-left');
  var rightCol = hero.querySelector('.sn-hero-chars-right');
  var headline = hero.querySelector('.sn-hero-headline');
  var doodles  = hero.querySelector('.sn-hero-doodles');

  hero.addEventListener('mousemove', function(e) {
    var rect = hero.getBoundingClientRect();
    var x = (e.clientX - rect.left - rect.width / 2) / rect.width;
    var y = (e.clientY - rect.top - rect.height / 2) / rect.height;

    if (leftCol)  leftCol.style.transform  = 'translateX(' + (-x * 18) + 'px) translateY(' + (-y * 12) + 'px)';
    if (rightCol) rightCol.style.transform = 'translateX(' + (x * 18) + 'px) translateY(' + (-y * 12) + 'px)';
    if (headline) headline.style.transform = 'translateX(' + (x * 6) + 'px) translateY(' + (y * 4) + 'px)';
    if (doodles) {
      var doodleEls = doodles.querySelectorAll('.sn-doodle');
      doodleEls.forEach(function(d, i) {
        var speed = (i % 3 === 0) ? 14 : (i % 3 === 1) ? 8 : 20;
        var dir = i % 2 === 0 ? 1 : -1;
        d.style.transform = 'translate(' + (x * speed * dir) + 'px, ' + (y * speed * 0.6) + 'px)';
      });
    }
  });

  hero.addEventListener('mouseleave', function() {
    if (leftCol)  leftCol.style.transform  = '';
    if (rightCol) rightCol.style.transform = '';
    if (headline) headline.style.transform = '';
    var doodleEls = hero.querySelectorAll('.sn-doodle');
    doodleEls.forEach(function(d) { d.style.transform = ''; });
  });
}

/* ---- Scroll Parallax (elements move at different scroll speeds) ---- */
function initScrollParallax() {
  var hero      = document.querySelector('.sn-hero');
  var leftCol   = hero ? hero.querySelector('.sn-hero-chars-left')  : null;
  var rightCol  = hero ? hero.querySelector('.sn-hero-chars-right') : null;
  var lsImg     = document.querySelector('.sn-ls-img');

  var ticking = false;
  window.addEventListener('scroll', function() {
    if (ticking) return;
    requestAnimationFrame(function() {
      var sy = window.scrollY;

      // Hero characters drift upward slightly as you scroll away
      if (window.innerWidth > 480) {
        if (leftCol && sy < 800)  leftCol.style.transform  = 'translateY(' + (sy * 0.12) + 'px)';
        if (rightCol && sy < 800) rightCol.style.transform = 'translateY(' + (sy * 0.12) + 'px)';
      }

      // Lifestyle photo Ken Burns effect on scroll
      if (lsImg) {
        var imgRect = lsImg.getBoundingClientRect();
        var inView = imgRect.top < window.innerHeight && imgRect.bottom > 0;
        if (inView) {
          var progress = (window.innerHeight - imgRect.top) / (window.innerHeight + imgRect.height);
          lsImg.style.transform = 'scale(' + (1 + progress * 0.05) + ') translateY(' + (progress * -20) + 'px)';
        }
      }

      ticking = false;
    });
    ticking = true;
  }, { passive: true });
}

/* ---- Personality Bars Animate from 0 on Scroll ---- */
function initPersonalityBarAnimation() {
  var bars = document.querySelectorAll('.sn-pdp-bar-fill');
  if (!bars.length) return;

  bars.forEach(function(bar) {
    var target = bar.style.width || '0%';
    bar.style.width = '0%';
    bar.setAttribute('data-target-width', target);
    bar.style.transition = 'width 1.2s cubic-bezier(0.4,0,0.2,1)';
  });

  var io = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) {
        setTimeout(function() {
          e.target.style.width = e.target.getAttribute('data-target-width');
        }, 200);
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.5 });

  bars.forEach(function(bar) { io.observe(bar); });
}

/* ---- Cart Icon Bounce on Add ---- */
function initCartBounce() {
  document.querySelectorAll('[data-sn-add-to-cart]').forEach(function(form) {
    form.addEventListener('submit', function() {
      var cartBtns = document.querySelectorAll('.sn-cart-btn');
      cartBtns.forEach(function(btn) {
        btn.classList.add('sn-cart-bounce');
        setTimeout(function() { btn.classList.remove('sn-cart-bounce'); }, 600);
      });
    });
  });
}

/* ---- Page Transition Fade + Schnerd Runner ---- */
function initPageTransition() {
  document.body.classList.add('sn-page-ready');

  // The sn-page-in keyframes animate <body>'s transform. Per spec, an
  // element that is the target of a transform animation establishes a
  // containing block for position:fixed descendants — and, a live check
  // found, breaks position:sticky ancestors-of-viewport math too — for
  // as long as that animation's effect is attached to the element,
  // REGARDLESS of what the transform's instantaneous value is (exactly
  // "none" mid-animation still counts) and regardless of playState.
  // anim.finish() only jumps the timeline to its end and reports
  // "finished" — with `animation: ... both` (fill-forwards), the effect
  // stays attached and still establishes that containing block forever
  // after, which is exactly why the mobile filter drawer (position:fixed)
  // was found rendering off past the bottom of the real viewport at
  // scrollY 0 instead of sliding up as a bottom sheet. Only anim.cancel()
  // actually detaches the effect. That's safe here specifically because
  // body has no other rule setting opacity/transform, so canceling drops
  // it right back to the animation's own "to" state (opacity:1,
  // transform:none) with zero visual difference.
  function finishPageInAnimation() {
    if (!document.body.getAnimations) return; // very old browser — nothing to do
    document.body.getAnimations().forEach(function (anim) {
      if (anim.animationName === 'sn-page-in') anim.cancel();
    });
  }
  document.body.addEventListener('animationend', function (e) {
    if (e.target === document.body && e.animationName === 'sn-page-in') finishPageInAnimation();
  });
  // Backup timer alongside animationend, for the stuck-"running" case above.
  setTimeout(finishPageInAnimation, 400);

  // Safety net: if the page is restored from the back/forward cache with
  // "sn-page-leaving" still stuck on <body> (e.g. it was mid-fade-out when the
  // user navigated away), clear it so the page isn't left permanently blank.
  window.addEventListener('pageshow', function() {
    document.body.classList.remove('sn-page-leaving');
    document.body.classList.add('sn-page-ready');
  });

  document.addEventListener('click', function(e) {
    var link = e.target.closest('a[href]');
    if (!link) return;
    var href = link.getAttribute('href');
    // Skip the fade-out for any same-page anchor link, whether it's written as
    // "#meet" or "{{ routes.root_url }}#meet" (e.g. "/#meet") — both just
    // scroll on the same page and never trigger a real navigation, so the
    // "leaving" class would otherwise get stuck on forever.
    var isSamePageAnchor = link.hash && link.pathname === window.location.pathname && link.search === window.location.search;
    if (!href || isSamePageAnchor || link.target === '_blank' ||
        href.indexOf('javascript') === 0 || href.indexOf('mailto') === 0) return;
    if (href.indexOf('http') === 0 && href.indexOf(window.location.hostname) === -1) return;

    e.preventDefault();

    // Schnerd sprints across — navigate after sprint completes
    var src = window.__snAssets && window.__snAssets.runner;
    document.body.classList.add('sn-page-leaving');

    if (src) {
      var runner = document.createElement('img');
      runner.src = src;
      runner.className = 'sn-page-runner';
      document.body.appendChild(runner);
      // Navigate after sprint animation finishes
      setTimeout(function() {
        if (runner.parentNode) runner.parentNode.removeChild(runner);
        window.location = href;
      }, 480);
    } else {
      setTimeout(function() { window.location = href; }, 300);
    }
  });
}

/* ============================================================
   Top 5 Movement Features
   ============================================================ */

/* ---- 1: Confetti burst — CSS transitions (reliable cross-browser) ---- */
function fireConfetti(btn) {
  if (!btn) return;
  var rect = btn.getBoundingClientRect();
  var cx = rect.left + rect.width / 2;
  var cy = rect.top + rect.height / 2;
  var pieces = ['♥','★','✦','♥','★','✦','•','♥','★','♥'];
  var colors = ['#FF2E92','#FFD21E','#4A8FD4','#3DBB4E','#E8920E','#ED2225'];

  pieces.forEach(function(sym, i) {
    var el = document.createElement('span');
    el.textContent = sym;
    var angle = (i / pieces.length) * Math.PI * 2;
    var dist  = 55 + Math.random() * 70;
    var dx    = Math.cos(angle) * dist;
    var dy    = Math.sin(angle) * dist - 55;
    var rot   = (Math.random() * 600 - 300) + 'deg';
    var size  = 10 + Math.random() * 9;

    el.style.cssText =
      'position:fixed;pointer-events:none;z-index:9999;user-select:none;' +
      'left:' + cx + 'px;top:' + cy + 'px;' +
      'color:' + colors[i % colors.length] + ';' +
      'font-size:' + size + 'px;font-weight:700;' +
      'opacity:1;transform:translate(-50%,-50%) scale(1) rotate(0deg);' +
      'transition:transform 0.8s cubic-bezier(0.2,0.8,0.4,1),opacity 0.7s ease 0.1s;';
    document.body.appendChild(el);

    // Two rAF frames to trigger transition
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        el.style.transform = 'translate(calc(-50% + ' + dx + 'px),calc(-50% + ' + dy + 'px)) scale(0.3) rotate(' + rot + ')';
        el.style.opacity   = '0';
      });
    });
    setTimeout(function() { if (el.parentNode) el.parentNode.removeChild(el); }, 900);
  });
}

/* ---- 2: Floating particles in hero ---- */
function initHeroParticles() {
  var hero = document.querySelector('.sn-hero');
  if (!hero) return;

  var container = document.createElement('div');
  container.className = 'sn-hero-particles';
  container.setAttribute('aria-hidden', 'true');
  hero.insertBefore(container, hero.firstChild);

  var symbols = ['♥','★','✦','•','♥','★','♥','✦'];
  var colors  = ['#FF2E92','#FFD21E','#4A8FD4','#E8920E','#3DBB4E','#ED2225'];

  for (var i = 0; i < 16; i++) {
    var p = document.createElement('span');
    p.textContent = symbols[i % symbols.length];
    p.className = 'sn-hero-particle';
    // Scatter randomly across the hero, each floats + fades independently
    p.style.cssText =
      'left:' + (5 + Math.random() * 90) + '%;' +
      'top:' + (10 + Math.random() * 75) + '%;' +
      'animation-delay:' + (-Math.random() * 6) + 's;' +
      'animation-duration:' + (4 + Math.random() * 5) + 's;' +
      'color:' + colors[i % colors.length] + ';' +
      'font-size:' + (7 + Math.random() * 8) + 'px;' +
      '--drift-x:' + ((Math.random() - 0.5) * 30) + 'px;' +
      '--drift-y:' + ((Math.random() - 0.5) * 20) + 'px;';
    container.appendChild(p);
  }
}

/* ---- 4: Hero curtain reveal (clip-path wipe left→right) ---- */
function initHeroCurtainReveal() {
  var headline = document.querySelector('.sn-hero-headline');
  if (!headline) return;
  headline.classList.add('sn-curtain-pending');

  var io = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) {
        e.target.classList.remove('sn-curtain-pending');
        e.target.classList.add('sn-curtain-reveal');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.1 });
  io.observe(headline);
}

/* ---- 5: "5.0" score counts up on scroll ---- */
function initScoreCounter() {
  var scoreEl = document.querySelector('.sn-rv-score-num');
  if (!scoreEl) return;

  var io = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (!e.isIntersecting) return;
      var startTime = null;
      var duration = 1400;

      function tick(ts) {
        if (!startTime) startTime = ts;
        var p = Math.min((ts - startTime) / duration, 1);
        // Ease out cubic
        var ease = 1 - Math.pow(1 - p, 3);
        scoreEl.textContent = (ease * 5.0).toFixed(1);
        if (p < 1) requestAnimationFrame(tick);
        else scoreEl.textContent = '5.0';
      }
      requestAnimationFrame(tick);
      io.unobserve(e.target);
    });
  }, { threshold: 0.6 });

  io.observe(scoreEl);
}
